import React from 'react';
import history from 'app/routes/history';
import IActions from 'app/types/actions';

import { Form } from 'reactstrap';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';

interface IConfirmTeamProps {
  appReady: boolean;
  connect: any;
  actions: IActions;
  teamId: string;
}

export default class ConfirmTeam extends React.Component<
IConfirmTeamProps,
{}
> {
  static defaultProps: IConfirmTeamProps = {
    connect: {},
    actions: undefined,
    appReady: false,
    teamId: undefined,
  };

  handleSubmit = async (e): Promise<void> => {
    e.preventDefault();
    this.props.actions.createTeamConnection(this.props.connect);

    history.push('/dashboard');
  };

  render(): React.ReactNode {
    return (
      <div className="row with-margin-top">
        <div className="col col-md-8 col-lg-6">
          <SectionGroup title="Confirm Connection">
            <div className="content-body">
              <div className="row content-row text-black">
                <div className="col">Association</div>
                <div className="col text-weight-medium-bold">{this.props.connect.organisationName}</div>
              </div>
              <div className="row content-row text-black">
                <div className="col">Section</div>
                <div className="col text-weight-medium-bold">{this.props.connect.sectionName}</div>
              </div>
              <div className="row content-row text-black">
                <div className="col">Season</div>
                <div className="col text-weight-medium-bold">{this.props.connect.seasonName}</div>
              </div>
              <div className="row content-row text-black">
                <div className="col">Competition</div>
                <div className="col text-weight-medium-bold">{this.props.connect.competitionName}</div>
              </div>
              <div className="row content-row text-black">
                <div className="col">Team</div>
                <div className="col text-weight-medium-bold">{this.props.connect.teamName}</div>
              </div>
              {/* <div className="row content-row">
                <div className="col">Team Code</div>
                <div className="col">{this.props.connect.organisationName}</div>
              </div> */}
            </div>
            <div className="row with-margin-top">
              <div className="col btn-flex-group less-padding">
                <div className="btn-flex-container">
                  <Form onSubmit={this.handleSubmit}>
                    <Button
                      className="btn-standard btn-success"
                      type="submit"
                    >
                      Confirm details
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </SectionGroup>
        </div>
      </div>
    );
  }
}
